import * as ActionTypes from 'state/actions/types'

const initialState = {
  isRequesting: false,
  isLoadingExports: false,
  exportFailed: false,
  exportSuccess: false,
  isFetchingConfig: false,
  isSavingConfig: false,

  isFetchingExportApiConfig: false,
  isSavingExportApiConfig: false,

  exports: [],
  tokens: [],
  
  reportingConfig: {
    region: '',
    country: '',
    clientIdentifier: '',
    useCaseIdentifier: ''
  },

  exportApiConfig: {
    amazonS3: {
      accessKey: '',
      secretAccessKey: '',
      region: '',
      endpoint: '',
      bucketName: ''
    },
    azureBlob: {
      connectionString: '',
      containerName: ''
    },
    googleStorage: {
      accessKey: '',
      secretAccessKey: '',
      region: '',
      endpoint: '',
      bucketName: ''
    },
    obsS3: {
      accessKey: '',
      secretAccessKey: '',
      region: '',
      endpoint: '',
      bucketName: ''
    },
    storageType: '',
    apiToken: ''
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case `${ActionTypes.RESET_EXPORTS_REQUEST}_START`:
    case `${ActionTypes.DELETE_EXPORT_ITEM_REQUEST}_START`:
    case `${ActionTypes.EXPORT_ANALYTICS_V2_REQUEST}_START`: {
      return {
        ...state,
        isRequesting: true
      }
    }

    case `${ActionTypes.RESET_EXPORTS_REQUEST}_SUCCESS`:
    case `${ActionTypes.RESET_EXPORTS_REQUEST}_FAIL`:
    case `${ActionTypes.DELETE_EXPORT_ITEM_REQUEST}_SUCCESS`:
    case `${ActionTypes.DELETE_EXPORT_ITEM_REQUEST}_FAIL`:
    case `${ActionTypes.EXPORT_ANALYTICS_V2_REQUEST}_SUCCESS`: {
      return {
        ...state,
        isRequesting: false,
        exportSuccess: true
      }
    }
    case `${ActionTypes.EXPORT_ANALYTICS_V2_REQUEST}_FAIL`: {
      return {
        ...state,
        isRequesting: false,
        exportFailed: true
      }
    }

    case `${ActionTypes.CLOSE_EXPORT_ERROR_MODAL}`: {
      return {
        ...state,
        exportFailed: false,
        exportSuccess: false
      }
    }

    case `${ActionTypes.LOAD_EXPORTS_REQUEST}_START`: {
      return {
        ...state,
        exports: [],
        isLoadingExports: true
      }
    }

    case `${ActionTypes.LOAD_EXPORTS_REQUEST}_SUCCESS`: {
      return {
        ...state,
        exports: Array.isArray(action?.response?.items) ? action.response.items : [],
        isLoadingExports: false
      }
    }

    case `${ActionTypes.LOAD_EXPORTS_REQUEST}_FAIL`: {
      return {
        ...state,
        exports: [],
        isLoadingExports: false
      }
    }

    case ActionTypes.UPDATE_REPORTING_CONFIG: {
      return {
        ...state,
        reportingConfig: {
          ...state.reportingConfig,
          [action.payload.key]: action.payload.value
        }
      }
    }

    case ActionTypes.UPDATE_EXPORT_API_CONFIG: {
      return {
        ...state,
        exportApiConfig: {
          ...state.exportApiConfig,
          [action.payload.key]: action.payload.value
        }
      }
    }

    case ActionTypes.UPDATE_EXPORT_API_AZURE_CONFIG: {
      return {
        ...state,
        exportApiConfig: {
          ...state.exportApiConfig,
          azureBlob: {
            ...state.exportApiConfig.azureBlob,
            [action.payload.key]: action.payload.value
          }
        }
      }
    }

    case ActionTypes.UPDATE_EXPORT_API_AMAZONS3_CONFIG: {
      return {
        ...state,
        exportApiConfig: {
          ...state.exportApiConfig,
          amazonS3: {
            ...state.exportApiConfig.amazonS3,
            [action.payload.key]: action.payload.value
          }
        }
      }
    }

    case ActionTypes.UPDATE_EXPORT_API_GOOGLE_CONFIG: {
      return {
        ...state,
        exportApiConfig: {
          ...state.exportApiConfig,
          googleStorage: {
            ...state.exportApiConfig.googleStorage,
            [action.payload.key]: action.payload.value
          }
        }
      }
    }

    case ActionTypes.UPDATE_EXPORT_API_OBS_CONFIG: {
      return {
        ...state,
        exportApiConfig: {
          ...state.exportApiConfig,
          obsS3: {
            ...state.exportApiConfig.obsS3,
            [action.payload.key]: action.payload.value
          }
        }
      }
    }

    case `${ActionTypes.FETCH_REPORTING_CONFIG_REQUEST}_START`: {
      return {
        ...state,
        isFetchingConfig: true,
        reportingConfig: {
          region: '',
          country: '',
          clientIdentifier: '',
          useCaseIdentifier: ''
        }
      }
    }

    case `${ActionTypes.FETCH_REPORTING_CONFIG_REQUEST}_SUCCESS`: {
      const config = action?.response?.result

      return {
        ...state,
        isFetchingConfig: false,
        reportingConfig: {
          region: config?.region || '',
          country: config?.country || '',
          clientIdentifier: config?.clientIdentifier || '',
          useCaseIdentifier: config?.useCaseIdentifier || ''
        }
      }
    }

    case `${ActionTypes.FETCH_REPORTING_CONFIG_REQUEST}_FAIL`: {
      return {
        ...state,
        isFetchingConfig: false
      }
    }


    case `${ActionTypes.SAVE_REPORTING_CONFIG_REQUEST}_START`: {
      return {
        ...state,
        isSavingConfig: true
      }
    }

    case `${ActionTypes.SAVE_REPORTING_CONFIG_REQUEST}_SUCCESS`: {
      return {
        ...state,
        isSavingConfig: false
      }
    }

    case `${ActionTypes.SAVE_REPORTING_CONFIG_REQUEST}_FAIL`: {
      return {
        ...state,
        isSavingConfig: false
      }
    }



    case `${ActionTypes.FETCH_EXPORT_API_CONFIG_REQUEST}_START`: {
      return {
        ...state,
        tokens: [],
        isFetchingExportApiConfig: true,
        exportApiConfig: {
          amazonS3: {
            accessKey: '',
            secretAccessKey: '',
            bucketName: ''
          },
          azureBlob: {
            connectionString: '',
            containerName: ''
          },
          googleStorage: {
            accessKey: '',
            secretAccessKey: '',
            bucketName: ''
          },
          obsS3: {
            accessKey: '',
            secretAccessKey: '',
            bucketName: ''
          },
          storageType: '',
          apiToken: ''
        }
      }
    }

    case `${ActionTypes.FETCH_EXPORT_API_CONFIG_REQUEST}_SUCCESS`: {
      const config = action?.response?.result?.config
      const tokens = action?.response?.result?.tokens

      return {
        ...state,
        tokens,
        isFetchingExportApiConfig: false,
        exportApiConfig: {
          amazonS3: {
            accessKey: config?.amazonS3?.accessKey || '',
            secretAccessKey: config?.amazonS3?.secretAccessKey || '',
            region: config?.amazonS3?.region || '',
            endpoint: config?.amazonS3?.endpoint || '',
            bucketName: config?.amazonS3?.bucketName || ''
          },
          azureBlob: {
            connectionString: config?.azureBlob?.connectionString || '',
            containerName: config?.azureBlob?.containerName || ''
          },
          googleStorage: {
            accessKey: config?.googleStorage?.accessKey || '',
            secretAccessKey: config?.googleStorage?.secretAccessKey || '',
            region: config?.googleStorage?.region || '',
            endpoint: config?.googleStorage?.endpoint || '',
            bucketName: config?.googleStorage?.bucketName || ''
          },
          obsS3: {
            accessKey: config?.obsS3?.accessKey || '',
            secretAccessKey: config?.obsS3?.secretAccessKey || '',
            region: config?.obsS3?.region || '',
            endpoint: config?.obsS3?.endpoint || '',
            bucketName: config?.obsS3?.bucketName || ''
          },
          storageType: config?.storageType || '',
          apiToken: config?.apiToken || ''
        }
      }
    }

    case `${ActionTypes.FETCH_EXPORT_API_CONFIG_REQUEST}_FAIL`: {
      return {
        ...state,
        isFetchingExportApiConfig: false
      }
    }


    case `${ActionTypes.SAVE_EXPORT_API_CONFIG_REQUEST}_START`: {
      return {
        ...state,
        isSavingExportApiConfig: true
      }
    }

    case `${ActionTypes.SAVE_EXPORT_API_CONFIG_REQUEST}_SUCCESS`: {
      return {
        ...state,
        isSavingExportApiConfig: false
      }
    }

    case `${ActionTypes.SAVE_EXPORT_API_CONFIG_REQUEST}_FAIL`: {
      return {
        ...state,
        isSavingExportApiConfig: false
      }
    }


    default: {
      return state
    }
  }
}
